"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M2 4.3284 4.8284 1.5l1.4142 1.4142-1.4142 1.4142 1.4142 1.4142L4.8284 7.157 2 4.3284zM16.214 1.5l2.8284 2.8284L16.214 7.157l-1.4142-1.4143 1.4142-1.4142-1.4142-1.4142L16.214 1.5zM10.4998 4c-1.3807 0-2.5 1.1193-2.5 2.5v5.3244c-.7411-1.1501-2.3217-1.5629-3.4825-.8322-1.158.7288-1.5132 2.251-.8038 3.4158 1.055 1.7284 2.054 3.4954 3.0372 5.2651.5022.904.855 1.5959 1.1354 2.3269h2.1188c-.3567-1.1158-.8067-2.0396-1.5059-3.2981-1.4243-2.5637-2.9114-5.0572-3.0506-5.2903-.1458-.2441-.1262-.5629.1342-.7268.2466-.1552.5527-.0605.7024.1773l1.8123 2.5922 1.9025-.6996V6.5a.5.5 0 0 1 1 0v7h2V9.2873l1 .4118V13.5h2v-2.9774l1 .4118V13.5h2v-1.7421c.4993.2056 1.0001.4495 1.0001 1.081v3.7861c0 1.9258-.8251 3.6296-1.5138 5.375h2.1609c.7213-1.7087 1.3529-3.4971 1.3529-5.375v-3.7861a2.9991 2.9991 0 0 0-1.8578-2.7735l-7.1423-2.941V6.5c0-1.3807-1.1193-2.5-2.5-2.5z"
  })];
};

exports.default = _default;